import React, { useEffect, useState } from 'react';
import { storyblokEditable } from '@storyblok/react';
import { Link } from 'react-scroll'; // Import Link from react-scroll

const NavBar = ({ blok }) => {
  const [navVisible, setNavVisible] = useState(false);

  const toggleNav = () => {
    setNavVisible(!navVisible);
  };

  // Auto-discover sections to build nav when blok.nav_items is not provided
  const [autoNav, setAutoNav] = useState([]);
  const [navOffset, setNavOffset] = useState(0);
  useEffect(() => {
    const scan = () => {
      const nodes = Array.from(document.querySelectorAll('section[data-nav="true"]'));
      const items = nodes
        .map((el) => ({
          label: el.getAttribute('data-label') || el.getAttribute('id') || 'Section',
          target: el.getAttribute('id') || '',
        }))
        .filter((i) => i.target);
      setAutoNav(items);
    };

    // Initial scan
    scan();

    // Observe for dynamic changes (Storyblok live updates)
    const observer = new MutationObserver(() => scan());
    observer.observe(document.body, { childList: true, subtree: true });
    // Compute dynamic offset based on navbar height and keep it updated on resize
    const computeOffset = () => {
      const el = document.querySelector('.navbar');
      if (el) {
        const h = el.getBoundingClientRect().height;
        setNavOffset(-Math.ceil(h));
      }
    };
    computeOffset();
    window.addEventListener('resize', computeOffset);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', computeOffset);
    };
  }, []);

  // Recompute offset when the navbar layout changes (e.g., mobile menu toggled)
  useEffect(() => {
    const el = document.querySelector('.navbar');
    if (el) {
      const h = el.getBoundingClientRect().height;
      setNavOffset(-Math.ceil(h));
    }
  }, [navVisible]);

  return (
    <nav {...storyblokEditable(blok)} className="navbar">
      <div className="logo-container">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            if (typeof window !== 'undefined' && window.scrollTo) {
              try {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              } catch {
                window.scrollTo(0, 0);
              }
            }
            // Close mobile menu if open
            setNavVisible(false);
          }}
          aria-label="Scroll to top"
        >
          <img src={blok.ecotech_logo.filename} alt="Ecotech Logo" className="ecotech-logo" decoding="async" fetchpriority="high" />
        </a>
      </div>
  <div id="primary-navigation" className={`nav-links ${navVisible ? 'show' : ''}`}>
        {(() => {
          const defaultNav = [
            { label: 'About', target: 'about_section' },
            { label: 'Mission', target: 'mission_section' },
            { label: 'Products and Services', target: 'products_and_services_section' },
            { label: 'Team', target: 'team_section' },
          ];
          const fromBlok = Array.isArray(blok.nav_items) && blok.nav_items.length
            ? blok.nav_items
                .map((item) => ({
                  label: item.label || item.text || item.name || 'Section',
                  target: item.target || item.target_id || item.anchor || item.to || '',
                }))
                .filter((i) => i.target)
            : null;
          const navItems = fromBlok || (autoNav.length ? autoNav : defaultNav);

          return navItems.map((i, idx) => (
            <Link key={`${i.target}-${idx}`} to={i.target} smooth={true} duration={500} offset={navOffset} onClick={() => setNavVisible(false)}>
              {i.label}
            </Link>
          ));
        })()}
        <a href={`mailto:${blok.contact_email}`} className="contact-link" onClick={() => setNavVisible(false)}>Contact</a>
      </div>
      <button
        className={`burger-menu ${navVisible ? 'open' : ''}`}
        aria-controls="primary-navigation"
        aria-expanded={navVisible}
        onClick={toggleNav}
        style={{ position: 'absolute', right: '20px', top: '20px', background: 'transparent', border: 'none', padding: 0, lineHeight: 0 }}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
  );
};

export default NavBar;